import { Description, Form, FormButton, SignupText, Title, Wrapper } from '../style';

import { NavLink } from 'react-router-dom';

import Input from '../../../components/Input';

const Forget = () => {
  return (
    <Wrapper>
      <Title>Forgot Password?</Title>
      <Description>
        Datox seamlessly integrates data from various sources, including databases, APIs, and
        external applications
      </Description>

      <Form>
        <Input label="Email" placeholder="Type your email" />
        <FormButton maxWidth={true}>Continue</FormButton>
        <SignupText>
          Don&apos;t have an account? <NavLink to="/signup">Sign up</NavLink>
        </SignupText>
      </Form>
    </Wrapper>
  );
};

export default Forget;
